/* AULBERY — Reviews (design R2)
   Moved 1:1 from the inline <script> in sections/as-reviews.liquid (v16
   structural). Each section root carries data-as-reviews and
   data-section-id; the per-instance values that used to be Liquid-
   interpolated into the script are read from the
   <script type="application/json" data-as-reviews-config> block inside the
   root. The two <dialog> elements render outside the root and are matched by
   data-as-reviews-dialog="<section id>". */
(function () {
  function readConfig(root) {
    var el = root.querySelector('[data-as-reviews-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function initRev(root) {
    if (!root || root.dataset.asrInit === '1') return;
    root.dataset.asrInit = '1';

    var cfg = readConfig(root);
    var sectionId = root.dataset.sectionId || '';
    var cleanups = [];

    var rowsWrap = root.querySelector('[data-asr-rows]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-asr-row]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-asr-filter]'));
    var dialogs = Array.prototype.slice.call(
      document.querySelectorAll('dialog[data-as-reviews-dialog="' + sectionId + '"]')
    );
    var perPage = parseInt(cfg.perPage, 10) || 5;
    var scrollOffset = parseInt(cfg.scrollOffset, 10) || 0;
    var page = 1;
    var filter = 'all';
    var order = rows.slice();
    var pager = root.querySelector('[data-asr-pager]');

    function dialogFor(key) {
      for (var i = 0; i < dialogs.length; i++) {
        if (dialogs[i].dataset.asrModal === key) return dialogs[i];
      }
      return null;
    }

    function openDialog(dlg) {
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        dlg.setAttribute('open', '');
      }
    }

    function eligible() {
      return order.filter(function (r) {
        return filter !== 'photos' || r.dataset.photo === '1';
      });
    }

    function pageBtn(label, target, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'asr-page-btn' + (opts && opts.on ? ' is-on' : '');
      b.textContent = label;
      if (opts && opts.disabled) b.disabled = true;
      b.addEventListener('click', function () {
        page = target;
        render(true);
      });
      return b;
    }

    function buildPager(pages) {
      if (!pager) return;
      pager.innerHTML = '';
      if (pages <= 1) return;
      pager.appendChild(pageBtn(cfg.prevText || 'Prev', Math.max(1, page - 1), { disabled: page === 1 }));
      pager.appendChild(pageBtn(cfg.nextText || 'Next', Math.min(pages, page + 1), { disabled: page === pages }));
    }

    function render(scroll) {
      var list = eligible();
      var pages = Math.max(1, Math.ceil(list.length / perPage));
      if (page > pages) page = pages;
      var start = (page - 1) * perPage;
      var end = start + perPage;

      order.forEach(function (r) { r.classList.add('is-hidden'); });
      list.slice(start, end).forEach(function (r) { r.classList.remove('is-hidden'); });

      buildPager(pages);

      var note = root.querySelector('[data-asr-disclaimer]');
      if (note) note.classList.toggle('is-hidden', page !== pages);

      if (scroll) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
        filter = c.dataset.asrFilter;
        page = 1;

        if (filter === 'recent') {
          order = rows.slice().sort(function (a, b) {
            return (parseInt(a.dataset.days, 10) || 0) - (parseInt(b.dataset.days, 10) || 0);
          });
        } else {
          order = rows.slice();
        }
        order.forEach(function (r) { rowsWrap.appendChild(r); });
        render(false);
      });
    });

    // photo lightbox
    var lightDlg = dialogFor('light');
    var lightTarget = lightDlg ? lightDlg.querySelector('[data-asr-light-target]') : null;
    root.querySelectorAll('[data-asr-light]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightDlg || !lightTarget) return;
        lightTarget.innerHTML = '<img src="' + btn.dataset.asrLight + '" alt="">';
        openDialog(lightDlg);
      });
    });

    // write a review
    var writeBtn = root.querySelector('[data-asr-open-write]');
    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        openDialog(dialogFor('write'));
      });
    }

    dialogs.forEach(function (dlg) {
      dlg.querySelectorAll('[data-asr-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        }
      });
      var formWrap = dlg.querySelector('[data-asr-form]');
      var doneWrap = dlg.querySelector('[data-asr-done]');
      var errorEl = dlg.querySelector('[data-asr-error]');
      var picks = Array.prototype.slice.call(dlg.querySelectorAll('[data-asr-pick]'));
      var bodyEl = dlg.querySelector('textarea');
      var counter = dlg.querySelector('[data-asr-counter]');
      var fileEl = dlg.querySelector('[data-asr-file]');
      var uploadBtn = dlg.querySelector('[data-asr-upload-btn]');
      var thumbs = dlg.querySelector('[data-asr-thumbs]');
      var doneBtn = dlg.querySelector('[data-asr-done-btn]');
      var rating = 0;
      var picked = [];
      var closeTimer = null;

      function paintStars() {
        picks.forEach(function (p, i) { p.classList.toggle('is-on', i < rating); });
      }
      picks.forEach(function (p) {
        p.addEventListener('click', function () {
          rating = parseInt(p.dataset.asrPick, 10) || 0;
          paintStars();
          clearError();
        });
      });

      function clearError() {
        if (errorEl) { errorEl.textContent = ''; errorEl.classList.add('is-hidden'); }
      }
      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.classList.remove('is-hidden');
      }

      var counterSep = cfg.counterSeparator == null ? ' / ' : String(cfg.counterSeparator);
      if (bodyEl && counter) {
        var max = parseInt(bodyEl.getAttribute('maxlength'), 10) || 400;
        bodyEl.addEventListener('input', function () {
          counter.textContent = bodyEl.value.length + counterSep + max;
          clearError();
        });
      }

      // Photos are previewed locally only — nothing is uploaded anywhere.
      function paintThumbs() {
        if (!thumbs) return;
        thumbs.innerHTML = '';
        picked.forEach(function (url, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'asr-thumb';
          b.setAttribute('aria-label', cfg.removeLabel || 'Remove photo');
          var img = document.createElement('img');
          img.src = url;
          img.alt = '';
          var badge = document.createElement('span');
          badge.textContent = cfg.removeGlyph == null ? 'x' : String(cfg.removeGlyph);
          b.appendChild(img);
          b.appendChild(badge);
          b.addEventListener('click', function () {
            URL.revokeObjectURL(picked[i]);
            picked.splice(i, 1);
            paintThumbs();
          });
          thumbs.appendChild(b);
        });
      }
      if (uploadBtn && fileEl) {
        uploadBtn.addEventListener('click', function () { fileEl.click(); });
        fileEl.addEventListener('change', function () {
          var maxPhotos = parseInt(cfg.maxPhotos, 10) || 3;
          var files = Array.prototype.slice.call(fileEl.files || []);
          files.forEach(function (f) {
            if (picked.length >= maxPhotos) return;
            picked.push(URL.createObjectURL(f));
          });
          fileEl.value = '';
          paintThumbs();
        });
      }

      function resetForm() {
        if (!formWrap || !doneWrap) return;
        picked.forEach(function (u) { URL.revokeObjectURL(u); });
        picked = [];
        rating = 0;
        paintStars();
        paintThumbs();
        if (bodyEl) bodyEl.value = '';
        if (counter && bodyEl) counter.textContent = '0' + counterSep + (bodyEl.getAttribute('maxlength') || '400');
        dlg.querySelectorAll('input[type="text"], input[type="email"]').forEach(function (i) { i.value = ''; });
        clearError();
        formWrap.classList.remove('is-hidden');
        doneWrap.classList.add('is-hidden');
      }

      var submit = dlg.querySelector('[data-asr-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (cfg.requireRating !== false) {
            if (rating === 0) { showError(cfg.errorRating || 'Pick a star rating first.'); return; }
          }
          if (cfg.requireBody !== false) {
            if (bodyEl && !bodyEl.value.trim()) { showError(cfg.errorBody || 'Write a few words about the product.'); return; }
          }
          if (!formWrap || !doneWrap) return;
          formWrap.classList.add('is-hidden');
          doneWrap.classList.remove('is-hidden');
          var auto = parseInt(cfg.autoClose, 10) || 0;
          if (auto > 0) {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
              if (typeof dlg.close === 'function') dlg.close();
              else dlg.removeAttribute('open');
            }, auto * 1000);
          }
        });
      }
      if (doneBtn) {
        doneBtn.addEventListener('click', function () {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      }
      dlg.addEventListener('close', function () {
        clearTimeout(closeTimer);
        resetForm();
      });

      cleanups.push(function () {
        clearTimeout(closeTimer);
        picked.forEach(function (u) { URL.revokeObjectURL(u); });
        picked = [];
      });
    });

    root.asReviewsCleanup = function () {
      cleanups.forEach(function (fn) { fn(); });
      cleanups = [];
      root.dataset.asrInit = '';
    };

    render(false);
    if (root.hasAttribute('data-asr-anim')) initAnimation(root, cleanups);
  }

  // ---------- scroll animation (summary band) ----------
  // Bars: CSS clip reveal per row (.asr--anim-armed -> .is-inview), each row
  // waiting one stagger step more. Numbers ([data-asr-count]: average, review
  // count, bar values) stay hidden (.asr-count-wait, space kept) until their
  // count starts, then pop in and count up from 0 to the printed figure,
  // each group after its own optional start delay (data-anim-delay-*),
  // keeping its decimals and any suffix ("%"). Stars pop in one by one.
  // Skipped with prefers-reduced-motion or no IntersectionObserver.
  var EASE = {
    'ease-out': { css: 'cubic-bezier(0.22, 1, 0.36, 1)', fn: function (t) { return 1 - Math.pow(1 - t, 4); } },
    'ease-in-out': { css: 'cubic-bezier(0.65, 0, 0.35, 1)', fn: function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2; } },
    linear: { css: 'linear', fn: function (t) { return t; } }
  };

  function initAnimation(root, cleanups) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var d = root.dataset;
    var duration = parseInt(d.animDuration, 10) || 1200;
    var stagger = parseInt(d.animStagger, 10);
    if (!isFinite(stagger) || stagger < 0) stagger = 0;
    var ease = EASE[d.animEase] || EASE['ease-out'];
    var threshold = Math.min(Math.max((parseInt(d.animThreshold, 10) || 30) / 100, 0.01), 1);
    var replay = d.animReplay === '1';
    function delay(key) {
      var v = parseInt(d['animDelay' + key], 10);
      return isFinite(v) && v > 0 ? v : 0;
    }
    var band = root.querySelector('.asr-band');
    if (!band) return;

    var rows = Array.prototype.slice.call(band.querySelectorAll('.asr-bar-row'));
    rows.forEach(function (row, i) {
      row.style.setProperty('--asr-anim-delay', delay('Bars') + i * stagger + 'ms');
    });

    // [node, delay, prefix, number, decimals, suffix]
    var counters = [];
    if (d.animCount === '1') {
      band.querySelectorAll('[data-asr-count]').forEach(function (node) {
        // The final figure, kept for DB - Section mirror (blocks/db-section-mirror.liquid),
        // which may read this node while the count-up shows 0.
        if (!node.hasAttribute('data-final')) node.setAttribute('data-final', node.textContent.trim());
        var m = /^(\D*?)(\d+(?:\.\d+)?)(.*)$/.exec(node.textContent.trim());
        if (!m) return;
        var row = node.closest('.asr-bar-row');
        var wait = row
          ? delay('Barvals') + rows.indexOf(row) * stagger
          : delay(node.closest('.asr-count-line') ? 'Count' : 'Avg');
        var dot = m[2].indexOf('.');
        counters.push([node, wait, m[1], parseFloat(m[2]), dot < 0 ? 0 : m[2].length - dot - 1, m[3]]);
      });
    }
    var stars = d.animStars === '1' ? band.querySelectorAll('.asr-star') : [];
    var bars = d.animBars === '1' && rows.length > 0;
    if (!bars && !counters.length && !stars.length) return;

    root.style.setProperty('--asr-anim-ease', ease.css);
    if (bars) root.classList.add('asr--anim-bars');
    if (stars.length) {
      root.classList.add('asr--anim-stars');
      var step = Math.min(Math.round(duration / (stars.length + 1)), 160);
      Array.prototype.forEach.call(stars, function (star, i) {
        star.style.transitionDelay = delay('Stars') + i * step + 'ms';
      });
    }
    if (d.animPop !== '0') root.classList.add('asr--anim-pop');

    function show(c, value) {
      c[0].textContent = c[2] + value.toFixed(c[4]) + c[5];
    }
    function reset() {
      counters.forEach(function (c) {
        if (c[0]._asrRaf) cancelAnimationFrame(c[0]._asrRaf);
        show(c, 0);
        c[0].classList.remove('asr-count-pop');
        c[0].classList.add('asr-count-wait');
      });
    }
    function play() {
      counters.forEach(function (c) {
        var node = c[0];
        var start = null;
        function step(now) {
          if (start === null) start = now + c[1];
          if (now < start) {
            node._asrRaf = requestAnimationFrame(step);
            return;
          }
          if (node.classList.contains('asr-count-wait')) {
            node.classList.remove('asr-count-wait');
            node.classList.add('asr-count-pop');
          }
          var t = Math.min(Math.max((now - start) / duration, 0), 1);
          show(c, t >= 1 ? c[3] : c[3] * ease.fn(t));
          if (t < 1) node._asrRaf = requestAnimationFrame(step);
        }
        node._asrRaf = requestAnimationFrame(step);
      });
    }
    function finish() {
      counters.forEach(function (c) {
        if (c[0]._asrRaf) cancelAnimationFrame(c[0]._asrRaf);
        show(c, c[3]);
        c[0].classList.remove('asr-count-wait', 'asr-count-pop');
      });
      root.classList.remove('asr--anim-armed', 'is-inview');
    }

    reset();
    root.classList.add('asr--anim-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (root.classList.contains('is-inview')) return;
          root.classList.add('is-inview');
          play();
          if (!replay) io.disconnect();
        } else if (replay && root.classList.contains('is-inview')) {
          root.classList.remove('is-inview');
          reset();
        }
      });
    }, { threshold: threshold });
    io.observe(band);
    cleanups.push(function () {
      io.disconnect();
      finish();
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-as-reviews]'), initRev);
  }

  function onUnload(e) {
    var scope = e && e.target && e.target.querySelectorAll ? e.target : null;
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-as-reviews]'), function (root) {
      if (typeof root.asReviewsCleanup === 'function') root.asReviewsCleanup();
    });
  }

  // the asset is loaded once per section instance; bind the document
  // listeners only the first time it runs
  if (document.documentElement.dataset.asReviewsBound !== '1') {
    document.documentElement.dataset.asReviewsBound = '1';
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', onUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

